'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InlineOverlayCloseButton = function (_BcReactComponent) {
  _inherits(InlineOverlayCloseButton, _BcReactComponent);

  function InlineOverlayCloseButton(props, context) {
    _classCallCheck(this, InlineOverlayCloseButton);

    var _this = _possibleConstructorReturn(this, (InlineOverlayCloseButton.__proto__ || Object.getPrototypeOf(InlineOverlayCloseButton)).call(this, props, context));

    _this.bindAll('handleClose');
    return _this;
  }

  _createClass(InlineOverlayCloseButton, [{
    key: 'handleClose',
    value: function handleClose(e) {
      e.preventDefault();

      if (this.props.handleClose) {
        this.props.handleClose();
      }

      if (this.context.handleClose) {
        this.context.handleClose();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'a',
        { href: '#close-inline-overlay', className: this.props.className, onClick: this.handleClose },
        this.props.children
      );
    }
  }]);

  return InlineOverlayCloseButton;
}(_baseBcReactComponent2.default);

InlineOverlayCloseButton.propTypes = {
  handleClose: _react.PropTypes.func,
  children: _react.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
  className: _react.PropTypes.string
};

InlineOverlayCloseButton.contextTypes = {
  handleClose: _react.PropTypes.func
};

InlineOverlayCloseButton.displayName = 'InlineOverlayCloseButton';

exports.default = InlineOverlayCloseButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-inline-overlay/lib/components/inline-overlay-close-button/components/InlineOverlayCloseButton.component.js
// module id = 1319
// module chunks = 1